import type { ImageComponentProps } from '@stereoagency/ui';
import { $globalSanityImageBuilder } from '@/sanity';
import imageSizeFromSanityAssetRef from './imageSizeFromSanityAssetRef';

type Image = {
  _type: 'image';
  asset: {
    _type: 'reference';
    _ref: string;
  };
};

export default function sanityImageAsProps(image: Image): ImageComponentProps {
  const imageSize = imageSizeFromSanityAssetRef(image.asset._ref);

  return {
    src: $globalSanityImageBuilder
      .image(image)
      .maxWidth(2000)
      .maxHeight(2000)
      .fit('fill')
      .quality(80)
      .url(),
    width: imageSize[0],
    height: imageSize[1]
  };
}
